<template>

    <modal @closeModal="closeModal" :show="showModal">

        <div class="flex-collumn padding-modal-td">

            <div class="img-tuto-container">

                <img class="modal-tuto-img" src="/img/icons/trash-white.svg" @click="closeModal">

            </div>

            <div class="modal-tuto-text-container">

                <markdown class="modal-tuto-text" :text="$tc('pop_up_delete_selected_newsletters', senders, { numberOfNewsletters: senders })"></markdown>

                <markdown class="modal-tuto-text" :text="$tc('pop_up_delete_total_emails', number, { numberOfEmails: number })"></markdown>

            </div>

            <button class="btn btn-amina" @click="accept">{{ $t('pop_up_delete_cta_delete') }}</button>

            <button class="btn btn-grey modal-tuto-cancel" @click="closeModal">{{ $t('pop_up_delete_cta_cancel') }}</button>

            <div class="little-checkbox-container">

                <checkbox ref="checkbox" class="little-checkbox" :little="true"></checkbox>

                <span class="little-checkbox-text">{{ $t('pop_up_delete_no_confirmation') }}</span>

            </div>

        </div>

    </modal>

</template>

<script>

import Checkbox from '@/components/inputs/Checkbox'
import Markdown from '@/components/Markdown'
import Modal from '@/components/modal/Modal'

import Storage from '@/helpers/storage'

import Tag from '@/modules/tag'

export default {

    name: 'modal-tuto-delete',

    components: { Modal, Markdown, Checkbox },

    data () {
        return {
            showModal: false,
            number: 0,
            senders: 0
        }
    },

    methods: {

        open (cards) {

            this.senders = cards.length
            this.number = cards
                .map(card => card.count)
                .reduce((acc, cur) => acc + cur, 0)

            Tag.popupAll(this, 'confirmation_delete')
            this.showModal = true
        },

        closeModal () {
            this.showModal = false
            Tag.clickAmplitude(this, 'cancel')
            this.$emit('close')
        },

        accept () {

            if (this.$refs.checkbox.value) {
                Tag.clickAmplitude(this, 'do_not_ask')
                Storage.setItem('disableModalDelete', true)
            }

            Tag.clickAmplitude(this, 'confirm')

            this.$emit('accept')
            this.showModal = false
        }

    }

}

</script>

<style scoped lang="scss">

    .img-tuto-container {
        width: 40px;
        height: 40px;
        border-radius: 100px;
        background-color: $sunset;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (min-width: $above-tablet-length) {
            height: 64px;
            width: 64px;
        }
    }

    .modal-tuto-img {
        height: 24px;
        object-fit: contain;
    }

    .modal-tuto-text {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        color: $secur-text;
        display: inline-block;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 18px;
            line-height: 1.33;
            color: $midnight;
        }
    }

    .modal-tuto-text-container {
        margin: 7px 0 17px;
        @media screen and (min-width: $above-tablet-length) {
            margin: 14px 0 18px;
        }
    }

    .modal-tuto-cancel {
        margin-top: 8px;
    }

    .padding-modal-td {
        padding: 8px 16px 20px;
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 32px 16px;
            max-width: 416px;
        }
    }


    .little-checkbox-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 29px;
        width: 100%;
    }

    .little-checkbox {
        background-color: white;
    }

    .little-checkbox-text {
        width: max-content;
        font-size: 12px;
        font-weight: 500;
        color: $secur-text;
        margin-left: 8px;
        @media screen and (min-width: $above-tablet-length) {
            margin-left: 12px;
            font-size: 14px;
        }
    }

</style>
